import * as React from 'react'

import {
  Box,
  Paper,
  Typography,
} from '@mui/material'

import { useDispatch } from 'react-redux';

import { CSideButton } from '../../components/common/Button';
import Template from '../../components/Sections/Template';
import KeySection from '../../components/Sections/KeySection';

function Setting() {
  const [tab, setTab] = React.useState('template');

  return (
    <Box className='w-full flex flex-column flex-basis flex-gap' >
      <Box sx={{paddingTop: 2, paddingLeft: 2}}>
        <Typography 
          sx={{ 
            fontSize: 24, 
            fontWeight: 600, 
            color: '#4A85F6'
          }}
        >
          Settings
        </Typography>
      </Box>
      <Box className='flex-basis'>
        <Paper className='w-full h-full flex flex-row' sx={{borderRadius: 4, margin: 1}}>
          <Box className='h-full' sx={{width: 320, borderRight: '1px solid #F5F5F5'}}>
            <Typography 
              sx={{ 
                fontSize: 16, 
                fontWeight: 400, 
                padding: 2,
              }}
            >
              Settings
            </Typography>
            <Box sx={{padding: 3}}>
              <CSideButton 
                sx={
                  tab==='template' ? 
                    { background: 'white', color: '#7354EF' }
                    : 
                    { background: 'white', color: 'rgba(0,0,0,0.7)'}
                  }
                onClick={() => setTab('template')}
              >
                PowerPoint Templates
              </CSideButton>
              <CSideButton 
                sx={
                  tab==='key' ? 
                    { background: 'white', color: '#7354EF' }
                    : 
                    { background: 'white', color: 'rgba(0,0,0,0.7)'}
                  }
                onClick={() => setTab('key')}
              >
                Default API Key
              </CSideButton>
            </Box>
          </Box>
          <Box className='flex-basis'>
            {tab === 'template'  && <Template/>}
            {tab === 'key'  && <KeySection/>}
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}

export default Setting;